import { qualifyProds } from "../api/api";
import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const ProductOfferingQualificationAction = {
    QUALIFY_PRODUCTS_SUCCESS : 'QUALIFY_PRODUCTS_SUCCESS',
    QUALIFY_PRODUCTS_FAILURE : 'QUALIFY_PRODUCTS_FAILURE'
} as const;

const qualifyProducts = () => {
    return function (dispatch:any) {
        qualifyProds().then((response) => {
            console.log(response);
            dispatch({type: ProductOfferingQualificationAction.QUALIFY_PRODUCTS_SUCCESS, payload:response.data});
            dispatch({type: SequenceManagerAction.QUALIFY_PRODUCTS_COMPLETE});
        })
        .catch((error) => {
            //Display error
            dispatch({type: SequenceManagerAction.GENERIC_ERROR, payload:error});
        })
    }
}

export { ProductOfferingQualificationAction, qualifyProducts };